import { useContext } from "react";

import { DeviceInfoContext } from "./DeviceInfoProvider";

/** Hook to access device information. Must be used within DeviceInfoProvider. */

export const useDeviceInfo = () => {
  const context = useContext(DeviceInfoContext);

  if (context === undefined) {
    throw new Error("useDeviceInfo must be used within DeviceInfoProvider");
  }

  return context;
};
